/* eslint-disable indent */
/* eslint-disable class-methods-use-this */
// eslint-disable-next-line object-curly-newline
import { getFirestore, getDoc, doc, collection, setDoc } from "firebase/firestore";
import { EventUserWaiver } from "@models/EventUserWaiver";
import useDate from "@/modules/useDate";

const { formatISODatetime } = useDate();

class EventUserWaiverDataService {
  eventCollectionName = "events";

  waiverCollectionName = "userWaivers";

  async getWaiver(eventId: string, userId: string): Promise<EventUserWaiver> {
    const db = getFirestore();

    const eventDoc = doc(db, this.eventCollectionName, eventId);

    const userWaiverRef = doc(
      collection(eventDoc, this.waiverCollectionName),
      // eslint-disable-next-line comma-dangle
      userId
    );

    const data = await getDoc(userWaiverRef);
    const results: EventUserWaiver = { ...data.data() } as EventUserWaiver;
    return results;
  }

  async save(eventId: string, userId: string): Promise<EventUserWaiver> {
    const db = getFirestore();
    const eventDoc = doc(db, this.eventCollectionName, eventId);
    const eventUserWaiverDoc = doc(eventDoc, this.waiverCollectionName, userId);
    const eventUserWaiver = {
      eventId,
      userId,
      acceptedOn: formatISODatetime(new Date()),
    };
    
    await setDoc(eventUserWaiverDoc, eventUserWaiver);
    return eventUserWaiver;
  }
}
export default new EventUserWaiverDataService();
